import { render, staticRenderFns } from "./customerComplaints.vue?vue&type=template&id=65189879&scoped=true&"
import script from "./customerComplaints.vue?vue&type=script&lang=js&"
export * from "./customerComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65189879",
  null
  
)

export default component.exports